<template>
  <div>
    <div class="app-card-header">
      <div class="heading-block">
        <h4 class="heading">{{ table.title }}</h4>
      </div>
      <div class="actions-block">
        <!--Category Select-->
        <div class="dropdown-filter">
          <v-autocomplete
            :value="filters.categories.checked"
            :items="filters.categories.items"
            :loading="categories.isLoading"
            :search-input.sync="categories.search"
            :ripple="false"
            background-color="rgba(48, 127, 255, 0.1)"
            clearable
            hide-details
            clear-icon
            append-icon="expand_more"
            item-text="category_name"
            item-value="category_id"
            label="Category"
            placeholder="Category"
            class="placeholder-hardcoded"
            solo
            flat
            multiple
            @change="checkFilter($event, 'category_id')"
          >
            <template v-slot:selection="data">
            </template>
          </v-autocomplete>
        </div>
        <!--Brands Select-->
        <div class="dropdown-filter">
          <v-autocomplete
            :value="filters.brands.checked"
            :items="filters.brands.items"
            :loading="brands.isLoading"
            :search-input.sync="brands.search"
            :ripple="false"
            background-color="rgba(48, 127, 255, 0.1)"
            clearable
            hide-details
            clear-icon
            append-icon="expand_more"
            item-text="manufacturer_name"
            item-value="manufacturer_id"
            label="Brand"
            placeholder="Brand"
            class="placeholder-hardcoded"
            solo
            flat
            multiple
            @change="checkFilter($event, 'manufacturer_id')"
          >
            <template v-slot:selection="data">
            </template>
          </v-autocomplete>
        </div>
        <!--Reset Button-->
        <v-btn
          :disabled="!filters.categories.checked.length && !filters.brands.checked.length"
          color="primary"
          flat
          small
          :ripple="false"
          @click="resetFilter()"
        >
          <v-icon>autorenew</v-icon>
        </v-btn>
        <div class="separator-line"></div>
        <!--Download Excel-->
        <v-tooltip top max-width="235px" :content-class="[`${getThemeColor === '0' ? 'dark-tooltip' : ''} +  i-tooltip`]">
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-btn
                class="mx-0"
                color="primary"
                flat
                small
                :ripple="false"
                @click="downloadHandler()"
              >
                <v-icon>icon-icon</v-icon>
              </v-btn>
            </div>
          </template>
          <span>Download Excel</span>
        </v-tooltip>
      </div>
    </div>
    <div class="card-body pa-0">
      <v-progress-circular
        v-if="table.loading && !table.items.length"
        :indeterminate="true"
        :size="75"
        height="3"
        color="primary"
        class="progress-circular" />
      <v-progress-linear
        v-if="table.loading && table.items.length"
        :indeterminate="true"
        height="3"
        color="primary"
        class="progress-card" />
      <v-data-table
        v-if="!table.noData"
        :items="!filters.brands.checked.length && !filters.categories.checked.length ? table.items : table.filteredItems"
        :headers="table.headers"
        :rows-per-page-items="rowsPerPageItems"
        :pagination.sync="pagination"
        :hide-actions="table.loading && table.items.length <= 0"
        :hide-headers="table.loading && table.items.length <= 0"
        no-data-text=""
        class="i-table"
      >
        <template v-slot:items="props">
          <tr>
            <td>{{ props.item.brand }}</td>
            <td>{{ props.item.product }}</td>
            <td>{{ props.item.category }}</td>
            <td>{{ props.item.sku }}</td>
            <td>{{ props.item['seller price'] }}</td>
            <td>{{ props.item['my price'] }}</td>
            <td>
              <v-tooltip top max-width="265px" :content-class="[`${getThemeColor === '0' ? 'dark-tooltip' : ''} +  i-tooltip`]">
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ props.item['suggested price'] }}
                  </span>
                </template>
                <span>{{ props.item.ruleApplied }}</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
      <i-no-data v-if="!table.loading && table.noData" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'profitOpportunities',
  props: {
    table: {
      type: [Object, Array],
      default: null
    },
    filters: {
      type: [Object, Array],
      default: null
    },
    categories: {
      type: [Object, Array],
      default: null
    },
    brands: {
      type: [Object, Array],
      default: null
    }
  },
  data: () => ({
    rowsPerPageItems: [5, 10, 25, 50, 100],
    pagination: {
      rowsPerPage: 5
    }
  }),
  mounted () {
    if (this.table.items.length <= 0) {
      this.requestProfitOpportunities()
    }
  },
  methods: {
    requestProfitOpportunities () {
      this.$store.dispatch('analyticsProfitOpportunitiesModule/getProfitOpportunities', {
        sellers: [],
        categories: [],
        brands: []
      })
    },
    checkFilter (items, type) {
      this.$store.commit('analyticsProfitOpportunitiesModule/ADD_filters', {item: items, type: type})
    },
    resetFilter () {
      this.$store.commit('analyticsProfitOpportunitiesModule/ADD_filters', {item: [], type: 'all'})
    },
    downloadHandler () {
      this.$emit('downloadExcel')
    }
  },
  computed: {
    getThemeColor () {
      return this.$store.state.auth.userInfo.themeColor
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/analytics/profitOpportunities.vue